'use client';

import Button from '@carvana/ds-button';
import { icon } from '@carvana/ds-styles';
import cx from 'classnames';
import { MapPin } from 'lucide-react';
import { useUserLocation } from '~/context/common/UserContext';
import { useModalContext } from '~/context/new-cars/ModalContext';

export default function GeolocationButton() {
  const { setGeolocationModalOpen } = useModalContext();
  const { zip } = useUserLocation();

  return (
    <Button
      aria-label={`Change location${zip ? `, currently ${zip}` : ''}`}
      className="w-fit"
      data-analytics-id="New Cars - Geo Location"
      data-testid="geo-location"
      onClick={() => setGeolocationModalOpen(true)}
      size="sm"
      variant="secondaryInverted"
    >
      <span className="flex items-center gap-sm">
        <MapPin
          aria-hidden
          color={icon.inverse}
          size={16}
          stroke="currentColor"
        />
        <span className={cx('m-0 truncate', { 'text-text-weak': !zip })}>
          {zip ?? 'Current location'}
        </span>
      </span>
    </Button>
  );
}
